module.exports = __webpack_public_path__ + "img/3-7-1.e135dacc.png";